import { ClientApplicationStages } from 'constants/enums';

export const applicationStagesOrder = [
  'NEW_APPLICATION_STAGE_CLIENT',
  'CLIENT_REVIEW_APPLICATION_STAGE_CLIENT',
  'ACCEPTED_APPLICATION_STAGE_CLIENT',
  'COMPLETED_APPLICATION_STAGE_CLIENT',
  'DECLINED_APPLICATION_STAGE_CLIENT',
  'HIRED_APPLICATION_STAGE_CLIENT'
];

export const INVITE_FOR_INTERVIEW_ALLOWED_STAGES: ClientApplicationStages[] = [
  ClientApplicationStages.NewApplicationStageClient,
  ClientApplicationStages.ClientReviewApplicationStageClient
];
